export default __webpack_public_path__ + "static/axie_infinity-204e4a8493eb16ba6536610b6d60e930.png";